import { useSelector } from 'react-redux';
import { permissions } from "./permissions"

function PermissionChecker({ children, requestedPermission }) {
    const role = useSelector(state => state.auth.user.role);

    const isPermitted = () => {
        const permission = permissions[role];
        if (permission) {
            return permission.permissions.filter(item => item.name === requestedPermission)[0].actions;
        }
        return [];
    }

    return (
        <div className={`${isPermitted().includes('readOnly') ? 'disabled' : ''} `}>
            {children}
        </div>
    );
}

export default PermissionChecker;
